<div class="modal flex-direction-column gap-54 padding-15px">
  <div>
    <span class="font-14 weight-700">Selecione o canal para o envio da mensagem</span>

    <app-select-one
      label="Canais"
      heightFormField="35px"
      placeholder="Selecione"
      [listaInput]="canais"
      [campo]="'nome'"
      [itemSelecionado]="canalSelecionado"
      (selecionarItem)="canalSelecionado = $event;">
    </app-select-one>

  </div>

  <div class="flex-direction-column gap-10">
    <app-button-padrao
      label="Enviar"
      color="#61B460"
      backgroundColor="white"
      borderColor="#61B460"
      borderStyle="solid"
      borderWidth="2px"
      fontWeight="600"
      width="100%"
      (buttonClick)="enviar()"
    ></app-button-padrao>

    <app-button-padrao
      label="Cancelar"
      color="#BD1D00"
      backgroundColor="white"
      borderColor="#BD1D00"
      borderStyle="solid"
      borderWidth="2px"
      fontWeight="600"
      width="100%"
      (buttonClick)="encerrar()"
    ></app-button-padrao>
  </div>
</div>
